import { symbol } from '@js/utils/currencyUtils';
import _ from 'lodash';

export function precision(number, significantFigures = 3) {
    number = parseInt(number);
    const numberLength = number.toString().length;
    return significantFigures - numberLength;
}

export function round(number, significantFigures = 3) {
    let prec = precision(number, significantFigures);
    return _.round(number, prec);
}

export function shortAmount(amount, significantFigures = 3) {
    amount = round(amount, significantFigures);
    if (amount >= 1000000) {
        amount /= 1000000;
    } else if (amount >= 1000) {
        amount /= 1000;
    }
    return amount;
}

export function suffix(amount, max = null) {
    let suf = '';
    if (amount >= 1000000) {
        suf = 'm';
    } else if (amount >= 1000) {
        suf = 'k';
    }
    if (max !== null && amount >= max) {
        suf += '+';
    }
    return suf;
}

export function shortFormat(amount, currency, max = null, significantFigures = 3) {
    return (currency ? symbol(currency) : '')
        + shortAmount(amount, significantFigures)
        + suffix(amount, max);
}

export function longFormat(amount, currency, significantFigures = 3) {
    return symbol(currency) + round(amount, significantFigures).toLocaleString();
}
